import { createReducer, on } from '@ngrx/store';
import { Address, Urgency } from '../../state';
import * as EligibleFundsActions from './eligible-funds.actions';
import { decodeQueryParams } from './eligible-funds.helpers';
import { OwnerData } from './eligible-funds.model';

export const eligibleFundsFeatureKey = 'eligibleFunds';

export interface EligibleFundsState {
  loading: boolean;
  ownerData?: OwnerData;
  addressChoices?: Address[];
  improvementList?: string[];
  urgency?: Urgency;
  email?: string;
  address?: Address;
}

export const initialState: EligibleFundsState = {
  loading: false,
};

export const reducer = createReducer(
  initialState,

  on(EligibleFundsActions.SetFromUrl, (state, { payload }) => {
    return {
      ...state,
      ownerData: decodeQueryParams(payload),
    };
  }),
  on(EligibleFundsActions.CreateProject, (state, { payload }) => {
    return {
      ...state,
      email: payload.email,
      improvementList: payload.improvements || [],
      urgency: payload.timeframes,
      loading: true,
    };
  }),
  on(EligibleFundsActions.CreateProjectSuccess, (state) => {
    return {
      ...initialState,
    };
  }),
  on(EligibleFundsActions.MultipleAddressFound, (state, { payload }) => {
    return {
      ...state,
      loading: false,
      addressChoices: payload,
    };
  }),
  on(EligibleFundsActions.SelectAddress, (state, { payload }) => {
    return {
      ...state,
      loading: true,
      address: payload,
    };
  }),
  on(EligibleFundsActions.DisplayError, (state) => {
    return {
      ...state,
      loading: false,
    };
  })
);
